import { render } from "./training-approval.vue?vue&type=template&id=197dcfa7&scoped=true"
import script from "./training-approval.vue?vue&type=script&lang=js"
export * from "./training-approval.vue?vue&type=script&lang=js"

import "./training-approval.vue?vue&type=style&index=0&id=197dcfa7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-197dcfa7"

export default script